export const BASE_URL = 'https://api.goodapp.vn/';

export const TRANG_THAI_KH = {
	TIEM_NANG: { value: '0', label: 'Tiềm năng' },
	CHINH_THUC: { value: '1', label: 'Chính thức' },
	THANH_VIEN: { value: '2', label: 'Thành viên' },
	DAI_LY: { value: '3', label: 'Đại lý' },
};
